import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { API_GET } from "../../helpers/api";
import { setServerTime } from "../../redux/actions/utilities";
import { useState } from "react";

let add = false;
let request_init = false;
let requested = false;

export function getBrowserVisibilityProp() {
  if (typeof document.hidden !== "undefined") {
    // Opera 12.10 and Firefox 18 and later support
    return "visibilitychange";
  } else if (typeof document.msHidden !== "undefined") {
    return "msvisibilitychange";
  } else if (typeof document.webkitHidden !== "undefined") {
    return "webkitvisibilitychange";
  }
}

export function getBrowserDocumentHiddenProp() {
  if (typeof document.hidden !== "undefined") {
    return "hidden";
  } else if (typeof document.msHidden !== "undefined") {
    return "msHidden";
  } else if (typeof document.webkitHidden !== "undefined") {
    return "webkitHidden";
  }
}

export function getIsDocumentHidden() {
  return !document[getBrowserDocumentHiddenProp()];
}

export function usePageVisibility() {
  const [isVisible, setIsVisible] = React.useState(getIsDocumentHidden());
  const onVisibilityChange = () => setIsVisible(getIsDocumentHidden());

  React.useEffect(() => {
    const visibilityChange = getBrowserVisibilityProp();

    document.addEventListener(visibilityChange, onVisibilityChange, false);

    return () => {
      document.removeEventListener(visibilityChange, onVisibilityChange);
    };
  });

  return isVisible;
}

export default function Clock() {
  let timer1 = null;
  const dispatch = useDispatch();
  const serverTime = useSelector((state) => state.utilities.serverTime);

  const isVisible = usePageVisibility();
  const [intervalState, setIntervalState] = useState(null);

  if (!isVisible) {
    add = true;
  }

  if (add && !request_init && !requested) {
    request_init = true;
  }
  // if (request_init && !requested && isVisible) {
  //   API_GET("system-date-time/full").then((res) => {
  //     dispatch(setServerTime(res.data));
  //   });
  //   add = false;
  //   request_init = false;
  //   requested = false;
  // }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps

    timer1 = setInterval(function () {
      API_GET("system-date-time/full").then((res) => {
        const time = res.data;
        setIntervalState(time);
      });
    }, 1000);

    return () => {
      clearInterval(timer1);
    };
  }, []);

  useEffect(() => {
    dispatch(setServerTime(intervalState));
  }, [intervalState]);

  return (
    <div className="km__c--navbar-time">
      {moment(intervalState).format("DD.MM.YYYY - HH:mm:ss")}
    </div>
  );
}
